module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      "sidebar-visible": _vm.menuActive || _vm.menuHover, "menu-pin sidebar-open": _vm.menuActive
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.routesPure.length > 0) ? _c('Sidebar', {
    class: {
      "visible": _vm.menuActive
    },
    attrs: {
      "menuActive": _vm.menuActive,
      "routesPure": _vm.routesPure
    },
    on: {
      "changeHover": _vm.changeHover
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-container",
    class: {
      "container-active": _vm.menuActive
    },
    attrs: {
      "id": "container"
    }
  }, [_c('Topbar', {
    attrs: {
      "realName": _vm.realName,
      "routesPure": _vm.routesPure
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loadpage"
  }, [_c('div', {
    staticClass: "loader"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-726a788f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/index.vue
// module id = 1779
// module chunks = 1